import React, { useEffect, useState } from 'react';
import {
  contarUsuarios,
  contarImoveis,
  contarImoveisPendentes,
} from '../../services/dashboardService';

export default function Dashboard() {
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [totalImoveis, setTotalImoveis] = useState(0);
  const [imoveisPendentes, setImoveisPendentes] = useState(0);

  useEffect(() => {
    const carregarDados = async () => {
      setTotalUsuarios(await contarUsuarios());
      setTotalImoveis(await contarImoveis());
      setImoveisPendentes(await contarImoveisPendentes());
    };
    carregarDados();
  }, []);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold mb-4">Dashboard Administrativo</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <IndicadorCard titulo="Usuários" valor={totalUsuarios} />
        <IndicadorCard titulo="Imóveis" valor={totalImoveis} />
        <IndicadorCard titulo="Pendentes" valor={imoveisPendentes} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
        <GraficoSelic />
        <GraficoIPCA />
      </div>
    </div>
  );
}
